import {
  FirstOpenRecord,
  FirstOpenStorage,
  parseFirstOpenRecord,
} from '@griply/utils';

const firstOpenKey = 'first-open';

// Keeps the once-only guard for this page load when localStorage is blocked (private mode, quota).
let inMemoryRecord: FirstOpenRecord | null = null;

export const firstOpenStorage: FirstOpenStorage = {
  read: () => {
    try {
      return (
        parseFirstOpenRecord(window.localStorage.getItem(firstOpenKey)) ??
        inMemoryRecord
      );
    } catch {
      return inMemoryRecord;
    }
  },
  write: (record) => {
    inMemoryRecord = record;
    try {
      window.localStorage.setItem(firstOpenKey, JSON.stringify(record));
    } catch {
      // localStorage unavailable
    }
  },
};
